module.exports = __webpack_public_path__ + "static/media/mototrcyk-motorcyclist-rider-blog-two.b1b6fbec.jpg";